'use es6';

export const createUpdateFocusedItem = appFocusLogic => (focusedItem, options = {}) => {
  return (dispatch, getState) => {
    const appState = getState();
    appFocusLogic(focusedItem, dispatch, appState, options);
  };
};